

























import {Component, Prop, Vue} from "vue-property-decorator";
import format from "@/valchrom/views/dataset/NumberFormat";

import {to_svg_data_uri,make_graph_svg} from "@/valchrom/views/dataset/LinearRegressionGraph";

import DetailedView from "@/valchrom/views/dataset/DetailedView.vue";
@Component({
    components: {DetailedView},
})
export default class Images extends Vue {
    name = 'Images'
    @Prop() images : any;

    to_src_url(data: any): string {
        if (typeof data === 'string' || data instanceof String)
            return ""+data
        else
            return to_svg_data_uri(make_graph_svg(data.data, data.labels, data.header));
    }

    formatExtraValue(extra:any){
        let unitsString = "";
        if(extra.unit) {
            unitsString = " " + extra.unit
        }
        return format(extra.value) + unitsString
    }

}
